module.exports = __webpack_public_path__ + "img/m-banner-rvzldswd-pt-PT.798bddb5.jpg";